import { MONTHLY } from 'shared/constants/options';

export const newExpense = {
  frequency: MONTHLY,
  value: null,
  errors: {},
};
